<template>
    <div id="XferToBinLocation" class='row'>

      <TabNav :tabs="['To Bin/Location', 'Receive Transfer']" :selected="selected" @selected="setSelected" >
        <Tab :isSelected="selected === 'To Bin/Location'">

          <ToBinLocation/>

        </Tab>
        <Tab :isSelected="selected === 'Receive Transfer'">

          <ReceiveTransfer/>

        </Tab>
      </TabNav>

      <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><!-- Temp -->

    </div>
</template>

<script>
  import TabNav from '../../../common/TabNav'
  import Tab from '../../../common/Tab'
  import ToBinLocation from './Xfer/ToBinLocation'
  import ReceiveTransfer from './Xfer/ReceiveTransfer'

  export default {
    name: 'XferToBinLocation',
    components: {
      TabNav,
      Tab,
      ToBinLocation,
      ReceiveTransfer,
    },
    mounted() {
      this.isPowerScan = true;
    },
    data() {
      return {
        selected: 'To Bin/Location',
        isPowerScan: this.$store.getters['Navigation/isPowerScan'],
      }
    },
    methods: {
        setSelected(tab) {
          this.selected = tab;
        },
        clearSelected() {
          this.selectedSkus.forEach(sku => this.removeSku(sku))
          this.selectedSkus.splice(0, this.selectedSkus.length)
        },
        clearAll() {
          this.selectedSkus.splice(0, this.selectedSkus.length)
          this.scannedSkus.splice(0, this.scannedSkus.length)
        },
        selectSku(sku) {
          if ( this.selectedSkus.includes(sku) ) {
            this.selectedSkus.splice(this.selectedSkus.indexOf(sku), 1)
          } else {
            this.selectedSkus.push(sku)
          }
        },
        removeSku(sku) {
          this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
        },
        addSku(sku) {
          if ( sku ) {
            if ( this.scannedSkus.indexOf(sku) == -1 ) { //TODO: not working
              this.scannedSkus.push(sku)
            }
          }
        },
        validateSku(e) {
          let enter = ( 'Enter' == e.key ? '' : '' )
          if ( 'Enter' == e.key ) {
            e.preventDefault()
            this.addSku(this.sku)
            this.sku = ''
          }
        },
        xferToBinLocation() {
          const {
            transferSku,
            scannedSkus
          } = this
          console.log('xferToBinLocation', transferSku, scannedSkus)
        },
        receiveTransfer() {
          const {
            receiveSku,
          } = this
          console.log('receiveTransfer', sku)
        }
    }
  }
</script>
